export const incrementResults = 15;
